/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseDictStrStrDataAnyOf } from './genericApiResponseDictStrStrDataAnyOf';

export type GenericApiResponseDictStrStrData = GenericApiResponseDictStrStrDataAnyOf | null;
